<template>
  <div class="Report">
    <el-radio-group v-model="checkedStatus" @change="tabchange">
      <el-radio-button
        v-for="state in states"
        :label="state.label"
        :key="state.text"
        >{{ state.text }}</el-radio-button
      >
    </el-radio-group>
    <el-card v-show="bloodpressureDisplay">
      <el-radio-group
        v-model="bloodpressureStatus"
        @change="bloodpressurechange"
      >
        <el-radio-button
          v-for="state in bloodpressurestates"
          :label="state.label"
          :key="state.text"
          >{{ state.text }}</el-radio-button
        >
      </el-radio-group>
      <el-row style="text-align: center">
        <el-radio-group
          v-model="timeStatus"
          style="margin: 0 auto"
          @change="timechange"
        >
          <el-radio-button
            v-for="state in timestates"
            :label="state.label"
            :key="state.text"
            >{{ state.text }}</el-radio-button
          >
        </el-radio-group>
      </el-row>
      <el-row>
        <div id="chartLineBox" style="width: 100%; height: 50vh"></div>
        <el-table :data="bloodpressureList" border :cell-style="statusStyle">
          <el-table-column prop="formatTime" label="日期"></el-table-column>
          <el-table-column prop="sbp" label="收缩压"></el-table-column>
          <el-table-column prop="dbp" label="舒张压"></el-table-column>
          <el-table-column
            prop="sbpConslution.conclusion"
            label="收缩压描述"
          ></el-table-column>
          <el-table-column
            prop="dbpConslution.conclusion"
            label="舒张压描述"
          ></el-table-column>
        </el-table>
      </el-row>
    </el-card>
    <el-card v-show="bloodsugarDisplay">
      <el-row style="text-align: center">
        <el-radio-group
          v-model="timeStatus1"
          style="margin: 0 auto"
          @change="timechange1"
        >
          <el-radio-button
            v-for="state in timestates1"
            :label="state.label"
            :key="state.text"
            >{{ state.text }}</el-radio-button
          >
        </el-radio-group>
      </el-row>
      <el-row>
        <div id="chartLineBox1" style="width: 100%; height: 50vh"></div>
        <el-radio-group v-model="timeStatus3" @change="timechange2">
          <el-radio-button
            v-for="state in timestates3"
            :label="state.stdCode"
            :key="state.stdName"
            >{{ state.stdName }}</el-radio-button
          >
        </el-radio-group>
        <el-table :data="conclution" border>
          <el-table-column prop="formatTime" label="日期"></el-table-column>
          <el-table-column prop="formatGlucose" label="血糖"></el-table-column>
          <el-table-column prop="conclusion" label="血糖描述"></el-table-column>
        </el-table>
      </el-row>
    </el-card>
    <el-card v-show="heartrateDisplay">
      <el-radio-group v-model="bloodsugarStatus" @change="switchtab1">
        <el-radio-button
          v-for="state in bloodsugarstates"
          :label="state.label"
          :key="state.text"
          >{{ state.text }}</el-radio-button
        >
      </el-radio-group>
      <el-row style="text-align: center">
        <el-radio-group
          v-model="timeStatus2"
          style="margin: 0 auto"
          @change="switchtab"
        >
          <el-radio-button
            v-for="state in timestates2"
            :label="state.label"
            :key="state.text"
            >{{ state.text }}</el-radio-button
          >
        </el-radio-group>
      </el-row>
      <el-row>
        <div id="chartLineBox2" style="width: 100%; height: 50vh"></div>
        <el-table :data="bloodpressureList1" border :cell-style="statusStyle1">
          <el-table-column prop="formatTime" label="日期"></el-table-column>
          <el-table-column prop="pul" label="心率"></el-table-column>
          <el-table-column
            prop="pulConslution.conclusion"
            label="心率描述"
          ></el-table-column>
        </el-table>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import axiosUtil from "../../utils/AxiosUtils.js";
import echarts from "echarts";
const PAGE = {
  pageNum: 1,
  pageSize: 10,
  pages: 1,
  total: 0,
};
export default {
  data() {
    return {
      PopupList3: [],
      bloodpressureList: [],
      bloodpressureList1: [],
      PopupList2: [],
      timeStatus3: "UNHANDLERGLUCOSESTDCODE",
      daterange: [],
      activeNames: ["1"],
      chuyuan: false,
      patName: "",
      jianchaList: true,
      display: false,
      obj: {},
      bianhao: [],
      choiceshow: false,
      CheckList: false,
      bingli: false,
      loading1: false,
      refuseDialogVisible: false,
      list: [],
      PopupList4: [],
      PopupList: [],
      PopupList1: [],
      states: [
        {
          label: "bloodpressure",
          text: "血压",
        },
        {
          label: "bloodsugar",
          text: "血糖",
        },
        {
          label: "heartrate",
          text: "心率",
        },
      ],
      prescriptionStatus: "Allprescriptions",
      projecttab: "whole",
      bloodpressurestates: [
        {
          label: "A",
          text: "数据A",
        },
        {
          label: "B",
          text: "数据B",
        },
      ],
      bloodsugarstates: [
        {
          label: "A",
          text: "数据A",
        },
        {
          label: "B",
          text: "数据B",
        },
      ],
      timestates: [
        {
          label: "week",
          text: "周",
        },
        {
          label: "month",
          text: "月",
        },
        {
          label: "year",
          text: "年",
        },
      ],
      timestates1: [
        {
          label: "week",
          text: "周",
        },
        {
          label: "month",
          text: "月",
        },
        {
          label: "year",
          text: "年",
        },
      ],
      timestates3: [],
      timestates2: [
        {
          label: "week",
          text: "周",
        },
        {
          label: "month",
          text: "月",
        },
        {
          label: "year",
          text: "年",
        },
      ],
      detail: {},
      InspectionReportDisplay: false,
      loading: false,
      page: PAGE,
      checkedStatus: "bloodpressure",
      detail1: {},
      obj1: {},
      list1: [],
      Inspection: false,
      detail2: {},
      CaseDisplay: false,
      SummaryListDisplay: false,
      obj2: {},
      list5: {},
      prescriptionDisplay: false,
      detail5: {},
      bloodpressureDisplay: true,
      bloodpressureStatus: "A",
      timeStatus: "week",
      timeStatus1: "week",
      timeStatus2: "week",
      bloodsugarDisplay: false,
      bloodsugarStatus: "A",
      heartrateDisplay: false,
      conclution: [],
      listdata: [],
      listdata1: [],
    };
  },
  props: ["userobj"],
  mounted() {
      this.xuyalist(this.timeStatus, this.bloodpressureStatus);
  },
  methods: {
    switchtab1() {
      this.bloodpressureList1 = [];
      this.xinlvlist(this.timeStatus2, this.bloodsugarStatus);
    },
    switchtab() {
      this.bloodpressureList1 = [];
      this.xinlvlist(this.timeStatus2, this.bloodsugarStatus);
    },
    xinlvlist(timeStatus2, bloodsugarStatus) {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.device.data.pcandhis.bloodpressure.list",
          token: localStorage.getItem("token"),
          idCard: _this.userobj.zjhm,
          periodType: timeStatus2,
        },
        ({ code, obj, page, msg }) => {
          if (code === "0") {
            let xAxisdata = [];
            let sup = [];
            let title = obj.time.formatStartTime + "~" + obj.time.formatEndTime;
            if (bloodsugarStatus == "B") {
              for (let i in obj.allDatasB) {
                xAxisdata.push(obj.allDatasB[i].formatTime);
                sup.push(obj.allDatasB[i].pul);
                for (let i in obj.allDatasB) {
                  _this.bloodpressureList1.push(obj.allDatasB[i]);
                }
              }
            } else {
              for (let i in obj.allDatasA) {
                xAxisdata.push(obj.allDatasA[i].formatTime);
                sup.push(obj.allDatasA[i].pul);
              }
              for (let i in obj.allDatasA) {
                _this.bloodpressureList1.push(obj.allDatasA[i]);
              }
            }
            // 指定图表的配置项和数据
            var option = {
              title: {
                text: title,
              },
              tooltip: {
                trigger: "axis",
              },
              legend: {
                data: ["心率"],
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              toolbox: {
                feature: {
                  saveAsImage: {},
                },
              },
              xAxis: {
                type: "category",
                boundaryGap: false,
                data: xAxisdata,
              },
              yAxis: {
                type: "value",
              },
              series: [
                {
                  name: "心率",
                  type: "line",
                  data: sup,
                },
              ],
            };
            // 使用刚指定的配置项和数据显示图表。
            this.$nextTick(function () {
              let chartBox = document.getElementById("chartLineBox2");
              var myChart = echarts.init(chartBox);
              myChart.setOption(option, true); //true用来解决数据不更新问题
            });
          } else {
            this.loading = false;
            this.bloodpressureList1 = [];
            this.$message.error(msg);
          }
        }
      );
    },
    bloodpressurechange() {
      this.bloodpressureList = [];
      this.xuyalist(this.timeStatus, this.bloodpressureStatus);
    },
    timechange() {
      this.bloodpressureList = [];
      this.xuyalist(this.timeStatus, this.bloodpressureStatus);
    },
    timechange1() {
      this.conclution = [];
      this.xutanglist(this.timeStatus1, this.timeStatus3);
    },
    timechange2() {
      this.conclution = [];
      this.xutanglist(this.timeStatus1, this.timeStatus3);
    },
    statusStyle({ row, column, rowIndex, columnIndex }) {
      if (
        this.bloodpressureList[rowIndex].dbpConslution.conclusionFlag != "0"
      ) {
        return "color:#ED3F14";
      }
    },
    statusStyle1({ row, column, rowIndex, columnIndex }) {
      if (
        this.bloodpressureList1[rowIndex].pulConslution.conclusionFlag != "0"
      ) {
        return "color:#ED3F14";
      }
    },
    xutanglist(periodType, timeStatus3) {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.device.data.pcandhis.glucose.list3",
          token: localStorage.getItem("token"),
          idCard: _this.userobj.zjhm,
          stdCode: timeStatus3,
          periodType: periodType,
        },
        ({ code, obj, page, msg }) => {
          if (code === "0") {
            // 指定图表的配置项和数据
            let title = obj.time.formatStartTime + "~" + obj.time.formatEndTime;
            let formatTime = [];
            let glucose = [];
            for (let i in obj.datas) {
              formatTime.push(obj.datas[i].formatTime);
              glucose.push(obj.datas[i].glucose);
              this.conclution.push(obj.datas[i].conclution);
              this.conclution[i].formatTime = obj.datas[i].formatTime;
              this.conclution[i].formatGlucose = obj.datas[i].formatGlucose;
            }
            this.timestates3 = obj.marks;
            for (let i in this.timestates2) {
              if (this.timestates3[i].select) {
                this.timeStatus3 = this.timestates3[i].stdCode;
              }
            }
            var option = {
              title: {
                text: title,
              },
              tooltip: {
                trigger: "axis",
              },
              legend: {
                data: ["血糖"],
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              toolbox: {
                feature: {
                  saveAsImage: {},
                },
              },
              xAxis: {
                type: "category",
                boundaryGap: false,
                data: formatTime,
              },
              yAxis: {
                type: "value",
              },
              series: [
                {
                  name: "血糖",
                  type: "line",
                  data: glucose,
                },
              ],
            };
            // 使用刚指定的配置项和数据显示图表。
            this.$nextTick(function () {
              let chartBox = document.getElementById("chartLineBox1");
              var myChart = echarts.init(chartBox);
              myChart.setOption(option, true); //true用来解决数据不更新问题
            });
          } else {
            this.loading = false;
            this.$message.error(msg);
          }
        }
      );
    },
    xuyalist(periodType, bloodpressureStatus) {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.device.data.pcandhis.bloodpressure.list",
          token: localStorage.getItem("token"),
          idCard: _this.userobj.zjhm,
          periodType: periodType,
        },
        ({ code, obj, page, msg }) => {
          if (code === "0") {
            let xAxisdata = [];
            let sup = [];
            let dbp = [];
            let title = obj.time.formatStartTime + "~" + obj.time.formatEndTime;
            if (bloodpressureStatus == "B") {
              for (let i in obj.allDatasB) {
                xAxisdata.push(obj.allDatasB[i].formatTime);
                sup.push(obj.allDatasB[i].sbp);
                dbp.push(obj.allDatasB[i].dbp);
                for (let i in obj.allDatasB) {
                  _this.bloodpressureList.push(obj.allDatasB[i]);
                }
              }
            } else {
              for (let i in obj.allDatasA) {
                xAxisdata.push(obj.allDatasA[i].formatTime);
                sup.push(obj.allDatasA[i].sbp);
                dbp.push(obj.allDatasA[i].dbp);
              }
              for (let i in obj.allDatasA) {
                _this.bloodpressureList.push(obj.allDatasA[i]);
              }
            }
            console.log(dbp);
            // 指定图表的配置项和数据
            var option = {
              title: {
                text: title,
              },
              tooltip: {
                trigger: "axis",
              },
              legend: {
                data: ["收缩压", "舒张压"],
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              toolbox: {
                feature: {
                  saveAsImage: {},
                },
              },
              xAxis: {
                type: "category",
                boundaryGap: false,
                data: xAxisdata,
              },
              yAxis: {
                type: "value",
              },
              series: [
                {
                  name: "收缩压",
                  type: "line",
                  data: sup,
                  markLine: {
                    symbol: "none",

                    /*symbol:"none",               //去掉警戒线最后面的箭头
                           label:{
                               position:"end"   ,       //将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
                            
                            
                           },*/
                    data: [
                      {
                        silent: false, //鼠标悬停事件  true没有，false有
                        lineStyle: {
                          //警戒线的样式  ，虚实  颜色
                          type: "dashed",
                          color: "#3398DB",
                        },
                        label: {
                          position: "end",
                          formatter: "",
                          fontSize: "14",
                        },
                        yAxis: 120, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                      },
                      {
                        silent: false, //鼠标悬停事件  true没有，false有
                        lineStyle: {
                          //警戒线的样式  ，虚实  颜色
                          type: "dashed",
                          color: "#3398DB",
                        },
                        label: {
                          position: "end",
                          formatter: "",
                          fontSize: "14",
                        },
                        yAxis: 80, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                      },
                    ],
                  },
                },
                {
                  name: "舒张压",
                  type: "line",
                  data: dbp,
                },
              ],
            };
            option.series[0].markPoint = {
              data: [
                {
                  type: "max",
                  name: "最大值",
                },
                {
                  type: "min",
                  name: "最小值",
                },
              ],
            };
            option.series[1].markPoint = {
              data: [
                {
                  type: "max",
                  name: "最大值",
                },
                {
                  type: "min",
                  name: "最小值",
                },
              ],
            };
            // 使用刚指定的配置项和数据显示图表。
            this.$nextTick(function () {
              let chartBox = document.getElementById("chartLineBox");
              var myChart = echarts.init(chartBox);
              myChart.setOption(option, true); //true用来解决数据不更新问题
            });
          } else {
            this.loading = false;
            this.$message.error(msg);
          }
        }
      );
      // myChart.setOption();
    },
    tabchange() {
      // if (!this.bianhao.medicalRecord) {
      //   this.$message.error("请先输入身份证号或者医保卡号");
      //   return;
      // }
      if (this.checkedStatus == "bloodpressure") {
        this.heartrateDisplay = false;
        this.bloodpressureDisplay = true;
        this.bloodsugarDisplay = false;
        this.bloodpressureList = [];
        this.xuyalist(this.timeStatus);
      } else if (this.checkedStatus == "bloodsugar") {
        this.heartrateDisplay = false;
        this.bloodpressureDisplay = false;
        this.bloodsugarDisplay = true;
        this.conclution = [];
        this.xutanglist(this.timeStatus1, this.timeStatus3);
      } else if (this.checkedStatus == "heartrate") {
        this.heartrateDisplay = true;
        this.bloodpressureDisplay = false;
        this.bloodsugarDisplay = false;

        this.xinlvlist(this.timeStatus2, this.bloodsugarStatus);
      }
    },
  },
};
</script>

<style lang="scss">
.Report {
  .el-table {
    margin-top: 15px;
  }
  .pagination-wrapper {
    padding: 20px 0;
  }
  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>
